module.exports = __webpack_public_path__ + "img/89.3.TP.17c9d849.png";